import type { UflrType } from 'lib/uflr';
import type { IAlbum } from 'reactApp/modules/albums/albums.types';
import type { WeblinkDownloadable } from 'reactApp/modules/public/public.types';
import type { CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import type { IPublicInfo, Kind, SubKind, Url, VirusScan } from 'reactApp/types/Tree';

export const enum VigboAccountLinkState {
    unlinked = 'unlinked',
    linked = 'linked',
}

export const enum VigboTariffState {
    active = 'active',
    finished = 'finished',
}

export interface VigboState {
    isLoading: boolean;
    isLoaded: boolean;
    list: Record<string, VigboItem>;
    linkState: VigboAccountLinkState;
}

export type VigboItem = IAlbum | VigboAlbumItem;

export interface VigboAlbumItem extends Partial<IPublicInfo>, WeblinkDownloadable {
    name: string;
    mtime: number;
    size: number;
    id: string;
    storage: EStorageType.vigbo;
    ext: string;
    nameWithoutExt: string;
    parent: string;
    cursor?: string;
    virusScan: VirusScan;
    isFolder: false;
    thumbnails?: Record<string, string>;
    url?: Url;
    kind: Kind;
    subKind: SubKind;
    isInFavorites: boolean;
    uflr?: UflrType;
    path: string;
    home: string;
    type: 'image';
    isReadOnly?: boolean;
    expiresTimeSize?: number;
    intraDomainShare?: boolean;
    // tempexp_18662-start
    weblink_views?: number;
    weblink_downloads?: number;
    // tempexp_18662-end
}

export interface CreateVigboAlbumRequestPayload {
    title: string;
    navigateToAlbum: boolean;
}
export interface VigboAlbumId {
    albumId: string;
}

export interface LoadVigboAlbumsListSuccessPayload {
    list: IAlbum[];
    cursor?: string;
}

export interface LoadVigboAlbumSuccessPayload {
    albumId: string;
    photos_count?: number;
    cursor?: string;
    list: VigboAlbumItem[];
    title: string;
}

export interface CreateVigboAlbumsSuccessPayload {
    id: string;
    title: string;
    photos_count: number;
    ctime: number;
    navigateToAlbum: boolean;
}

export interface SelectVigboAlbumAndAddItemsPayload {
    items: CloudItem[];
}

export interface VigboLinkState {
    linkState: VigboAccountLinkState;
}
